export const DATA_MORPH_SEGMENT = 'data-morph';
export const JOB_SETS_SEGMENT = 'etl-subsystem';
export const JOB_GRAPH_SEGMENT = 'graph';
